<!-- kontejner -->
<div class="el_height ui-lg-12 ui-md-12 ui-sm-12">

    <div class="ui-sm-12" [ngClass]="(report)?'ui-g-3':'ui-g-3'">
        <span class="ui-float-label">
            <p-dropdown [options]="this.reports" optionLabel="name" [autoDisplayFirst]=false [(ngModel)]="report"
                dataKey="id" (onChange)="dropDownOnChange($event)"></p-dropdown>
            <label style="top: -.75em; font-size: 12px;">{{this.label}}</label>
        </span>
    </div>
    <div class="ui-g-7 ui-sm-8" [ngClass]="(report)?'':'hidden'">
        <span class="md-inputfield">
            <!--<p-chips [(ngModel)]="formulaElement" allowDuplicate=false (onRemove)="onChipRemove()">
                <ng-template let-item pTemplate="item">
                    <div pTooltip="{{item.Description}}" tooltipPosition="top" [escape]=false>
                        <span>{{item.RowNo}}</span>
                    </div>
                </ng-template>
            </p-chips>-->
            <div class="my-chip-box">
                <div class="my-chip" *ngFor="let col of formulaElement">
                    <div class="my-chip-content"  pTooltip="{{ col.Description }}" tooltipPosition="top" tooltipStyleClass="custom-tooltip-content" [escape]="false">
                        <span >{{ col.RowNo }}</span>
                    </div>
                    <div class="my-chip-close" (click)="this.removeAccounts(col.IdLine)">
                        <svg class="my-chip-svg" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                            <path
                                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z">
                            </path>
                        </svg>
    
                    </div>
                </div>
            </div>
        </span>
        <p-dialog [modal]="true" [draggable]="false" [closable]="false" [header]="this.name" [(visible)]="formulaPickerVisible" *ngIf="formulaPickerVisible"
            [style]="{width: '800px'}" appendTo="body">
            <div class="ui-g">
                <div class="ui-g-12">
                    <list-table
                        [inputListNodes]="formula"
                        [listColumns]="tableColumns"
                        [loadingListNodes]="loading"
                        [(selected)]="selectedFormula"
                        selectionMode="multiple"
                    ></list-table>
                </div>
            </div>
            <div class="ui-g">
                <div class="ui-g-12">
                    <button type="button" label="OK" pButton icon="ui-icon-check" (click)="okClickFormula()" style="margin-right: 0.5em;"></button>
                    <button type="button" label="Cancel" pButton icon="ui-icon-cancel" (click)="formulaPickerVisible=false;"></button>
                </div>
            </div>
        </p-dialog>
    </div>

    <div class="ui-g-2 ui-sm-4" [ngClass]="(report)?'':'hidden'">
        <button icon="ui-icon-touch-app" label="Pick" pButton (click)="onFormulaPicker()"></button>
    </div>
</div>
